module.exports = __webpack_public_path__ + "static/media/2019-07-31-01.240885c3.jpg";